import React from "react";
import { Radio, FormControlLabel } from "@mui/material";
import { Subtask, SUBTASK_TYPE } from "./ProjectConfigurationTypes";
import { ContentStatus } from "./SubtaskComponent";
import ContentStatusIndicator from "./ContentStatusIndicator";
import SubtopicInfoTable from "./SubtopicInfoTable";

interface ProjectCodingViewProps {
  subtask: Subtask;
  subtopicInfo: { subtopic_name?: string; topic_name?: string; subject_name?: string } | null;
  viewModeContent: any;
  loadingViewData: boolean;
  contentStatus?: ContentStatus | null;
}

/**
 * ProjectCodingView Component
 * Displays project coding content in view mode
 * Shows all questions with radio buttons (single selection)
 */
const ProjectCodingView: React.FC<ProjectCodingViewProps> = ({
  subtask,
  subtopicInfo,
  viewModeContent,
  loadingViewData,
  contentStatus
}) => {
  if (loadingViewData) {
    return <div>Loading...</div>;
  }

  if (!viewModeContent || !viewModeContent.content) {
    return <div className="text-muted">No data available</div>;
  }

  const selectedId = (subtask.id && String(subtask.id).trim()) ? String(subtask.id).trim() : "";

  return (
    <div>
      <SubtopicInfoTable subtopicInfo={subtopicInfo} />
      
      {Object.keys(viewModeContent.content).map((levelKey) => {
        const levelQuestions = Array.isArray(viewModeContent.content[levelKey]) ? viewModeContent.content[levelKey] : [];
        
        return (
          <div key={levelKey}>
            {levelQuestions.map((question: any) => {
              const itemId = question?.content_id ? String(question.content_id).trim() : "";
              if (!itemId) return null; // Skip invalid questions
              
              const isSelected = itemId === selectedId;
              const timeStr = question?.duration_minutes != null ? String(question.duration_minutes) : "0";
              
              return (
                <div key={question.content_id} className="d-flex mb-2 align-items-center">
                  <div className="d-flex align-items-start p-2 border rounded flex-grow-1">
                    <FormControlLabel
                      control={
                        <Radio
                          checked={isSelected}
                          disabled
                        />
                      }
                      label={
                        <div style={{ marginLeft: "8px", fontSize: "12px", marginTop: "4px", color: "#000" }}>
                          {question.title || question.content_id}
                        </div>
                      }
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          color: "#000 !important"
                        }
                      }}
                    />
                  </div>
                  <span className="d-flex align-items-center gap-2">
                    <strong>{timeStr}m</strong>
                    <ContentStatusIndicator
                      contentId={itemId}
                      contentType={SUBTASK_TYPE.PROJECT_CODING}
                      contentStatus={contentStatus}
                    />
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ProjectCodingView;
